<template>
    <section id="adega" class="section py-20 bg-rose-950">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex flex-col lg:flex-row items-center">
                <div class="lg:w-1/2 mb-10 lg:mb-0 lg:pr-10">
                    <h2 class="text-3xl md:text-4xl font-bold text-white mb-6">Nossa Seleção de Vinhos</h2>
                    <p class="text-lg text-white mb-6">Explore uma adega exclusiva com rótulos selecionados mundialmente.</p>
                    <p class="text-lg text-white mb-8">Degustações e harmonizações guiadas por sommeliers renomados.</p>
                    <div class="bg-white/20 backdrop-blur-sm p-6 rounded-lg">
                        <div class="flex items-center mb-4">
                            <i class="fas fa-wine-glass-alt text-white text-xl mr-3"></i>
                            <span class="text-white font-semibold">Experiência Única</span>
                        </div>
                        <p class="text-white">Desfrute dos melhores vinhos em um ambiente aconchegante e sofisticado.</p>
                    </div>
                </div>

                <!-- Carrossel -->
                <div class="lg:w-1/2">
                    <Swiper :modules="[Grid, Autoplay]" :slides-per-view="2" :grid="{ rows: 2, fill: 'row' }" :space-between="24" :loop="images.length > 4" :autoplay="images.length > 4 ? { delay: 4000, disableOnInteraction: false } : false" class="w-full p-4 bg-transparent">
                        <SwiperSlide v-for="(image, index) in images" :key="index" class="overflow-visible">
                            <img :src="image.src" :alt="image.alt" class="w-full h-72 object-cover rounded-lg shadow-lg transition-transform duration-300 ease-in-out
                                hover:scale-110 hover:z-10 will-change-transform" style="transform-origin: center center;" />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>

            <div class="grid md:grid-cols-3 gap-8 mt-12">
                <div class="text-center">
                    <div class="bg-rose-900 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-wine-bottle text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Variedade Internacional</h3>
                    <p class="text-gray-200">Rótulos selecionados das principais regiões vinícolas do mundo, para todos os paladares.</p>
                </div>
                <div class="text-center">
                    <div class="bg-rose-900 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-cheese text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Harmonização Perfeita</h3>
                    <p class="text-gray-200">Queijos, embutidos e pratos que realçam os sabores únicos de cada vinho.</p>
                </div>
                <div class="text-center">
                    <div class="bg-rose-900 text-white p-4 rounded-full inline-block mb-4">
                        <i class="fas fa-glass-cheers text-2xl"></i>
                    </div>
                    <h3 class="text-xl font-bold text-white mb-3">Experiência Sensorial</h3>
                    <p class="text-gray-200">Degustações guiadas por sommeliers em um ambiente sofisticado e acolhedor.</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Grid } from 'swiper/modules';

const images = [
    { src: new URL('https://revistaadega.uol.com.br/media/colecao_vinhos.jpg', import.meta.url).href, alt: 'Adega de vinhos' },
    { src: new URL('https://cdn.awsli.com.br/1954/1954169/arquivos/vinhos-portugueses-de-luxo-1200x900.jpg', import.meta.url).href, alt: 'Taças de vinho' },
    { src: new URL('https://descobrindoaitalia.com/wp-content/uploads/2022/01/wine-1761613_1280.jpg', import.meta.url).href, alt: 'Degustação de vinho' },
    { src: new URL('https://cnabrasil.org.br/storage/arquivos/vinho-abre.jpg', import.meta.url).href, alt: 'Garrafas de vinho' },
    { src: new URL('https://cdn.awsli.com.br/1954/1954169/arquivos/vinhos-portugueses-de-luxo-1200x900.jpg', import.meta.url).href, alt: 'Vista panorâmica' },
    { src: new URL('https://revistaadega.uol.com.br/media/colecao_vinhos.jpg', import.meta.url).href, alt: 'Área de lazer' },
];
</script>
